import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as rxjs from 'rxjs'

import * as routeBound from '../../../route-bound'
import * as records from '../records'

import { Api } from './api.service'
import type { TypeParams } from './types'

/**
 * Org assignments collection for fetching space org assignments
 */
@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams> {
  constructor() {
    const scenarioContext = ngCore.inject(routeBound.scenario.Context.TOKEN)
    const recordsEc = ngCore.inject(records.Collection)

    super({
      api: ngCore.inject(Api),
      context$: rxjs
        .combineLatest([
          scenarioContext,
          recordsEc.plugins.currentEntityPlugin.feature.selectors.getId()
            .asObservable,
        ])
        .pipe(
          rxjs.map(([context, spaceRecordId]) => {
            if (!context || !ents.core.dms.data.Record.Id.isId(spaceRecordId)) {
              return undefined
            }

            return { ...context, spaceRecordId }
          }),
        ),
      identify: assignment => assignment.id,
      name: ec.Name.Predefined.SpaceOrgAssignment,
      plugins: {
        additionalFactories: [
          new ds.table.ec.Factory<TypeParams>(collection => ({
            rowConfig: ({ entity: assignment }) => {
              const record =
                recordsEc.plugins.currentEntityPlugin.feature.selectors
                  .getEntity()
                  .asSignal()
              // Assignments are managed at cluster level for clustered rooms,
              // and are locked entirely once the room's survey is signed off.
              const canEditAssignment =
                !record?.clusterId &&
                record?.surveyStatus !== ents.extra.space.SurveyStatus.SignedOff

              return {
                iconsConfigs: [
                  ...(canEditAssignment
                    ? [
                        {
                          class: 'atn-icon atn-trash atn-red',
                          onClick: () => {
                            collection.plugins.editingPlugin.feature.actions.markForDeletion
                              .from(
                                `Table.Row-${assignment.id}.Icons.Trash.Clicked`,
                              )
                              .dispatch({ id: assignment.id })
                          },
                        },
                      ]
                    : []),
                ],
              }
            },
          })),
        ],
      },
    })
  }
}
